import { render, staticRenderFns } from "./CodeSnippets.vue?vue&type=template&id=542fab30&scoped=true&"
import script from "./CodeSnippets.vue?vue&type=script&lang=js&"
export * from "./CodeSnippets.vue?vue&type=script&lang=js&"
import style0 from "./CodeSnippets.vue?vue&type=style&index=0&id=542fab30&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542fab30",
  null
  
)

export default component.exports